module.exports = __webpack_public_path__ + "static/media/mira_community_t_header.7b3fa277.png";